export default class ParallaxAnimator {
    constructor() {
      this.elements = document.querySelectorAll('.gr-parallax');
      this.init();
    }
  
    applyParallax(event, e) {
      const rect = e.getBoundingClientRect();
      let posX = (event.clientX - (rect.left + rect.width / 2)) / 15;
      let posY = (event.pageY - (window.scrollY + rect.top + rect.height / 2)) / 15;
  
      const maxX = rect.width / 2;
      const maxY = rect.height / 2;
  
      posY = Math.max(Math.min(posY, maxY), -maxY);
      posX = Math.max(Math.min(posX, maxX), -maxX);
  
      if (e.classList.contains('p-negative')) {
        posY = -posY;
        posX = -posX;
      }
  
      e.style.transform = `translate3d(${posX}px, ${posY}px, 0)`;
    }
  
    init() {
      document.addEventListener('mousemove', (e) => {
        this.elements.forEach((el) => this.applyParallax(e, el));
      });
    }
  }
  